import React, { useState } from 'react';

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleFAQ = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div className={`faq-question ${isOpen ? 'open' : ''}`} onClick={toggleFAQ}>
        {question}
        <span className={`faq-toggle ${isOpen ? 'open' : ''}`}>{isOpen ? '-' : '+'}</span>
      </div>
      {isOpen && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

function FAQ() {
  const faqs = [
    {
      question: 'What can I buy Travel Insurance online?',
      answer: 'Purchase travel insurance or travel takaful effortlessly for yourself and your loved ones through  Smartchoice in just a few minutes. We provide an intelligent comparison tool to swiftly discover the finest travel health insurance options and the convenience of purchasing using a variety of payment methods such as  Visa or Master Debit or Credit Card, JazzCash, Keenu Wallet, Bank Transfer, or Cash on Delivery. Our commitment includes a speedy turnaround for your travel health insurance policy, with delivery promised within 60 minutes.Our platform boasts a wide array of top insurance providers, including EFU, Jubilee, Adamjee, Habib, UIC, TPL, IGI, and other esteemed insurance companies in Pakistan. Whether you are applying for a Schengen visa, Turkey visa, USA or Canada visa, or traveling anywhere in the world, rest assured you will discover a comprehensive insurance plan to suit your needs',
    },

    {
      question: 'What steps should I take to secure Car Insurance?',
      answer: 'Discover comprehensive assistance for your car insurance needs through our dedicated insurance advisor website. Our team of experts is here to guide you through the process, helping you choose the ideal coverage that suits your vehicle and circumstances. With personalized advice and a wealth of information at your fingertips, trust us to navigate the insurance landscape and find the perfect policy for you.',
    },

    {
      question: 'What are the steps to purchasing Health Insurance through an online platform?',
      answer: 'Buying health insurance online is simple with our platform. Begin by filling out our user-friendly form to receive personalized quotes. Our advisors are available to guide you through the options, ensuring you find the perfect coverage for your needs. Once you have chosen a plan ; complete the secure online purchase process to safeguard your health and peace of mind.',
    },

    {
      question: 'What points shall I consider while choosing my plan?',
      answer: 'Comparing insurance plans is easy with our platform. Simply enter your details and preferences, and our comparison tool will display a side-by-side analysis of available options. You can easily compare coverage, premiums, deductibles, and more to make an informed decision. Our advisors are also on hand to provide expert guidance and help you choose the plan that best fits your needs.',
    },

    {
      question: 'Why should I buy Car Tracker?',
      answer: 'Nothing surpasses the significance of family in our lives; any additional precautions we can implement to guarantee their safety are invaluable. Trackers aid in monitoring the locations of our loved ones, contributing to the mitigation of car theft risks and facilitating the recovery of stolen vehicles.',
    },

    {
      question: 'What aspects are excluded from Car Insurance coverage?',
      answer: 'Car insurance typically does not cover wear and tear, depreciation, consequential losses, or mechanical and electrical breakdowns. Moreover, damage to batteries and tires is usually covered only up to 50% of their replacement value, unless the vehicle is declared a total loss according to the policy terms. It is essential to thoroughly read the complete policy wording attached to your insurance plan. For any clarification or assistance, you can always reach out to  our Insurance experts who are here to help.',
    },

    // Add more FAQ items as needed
  ];

  return (

    <div className="faq-list">
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
}



export default FAQ;